import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { loginToken, logOut } from "../../../helpers/LocalStorageHelper";
import { handleError } from "../../../helpers/ErrorHelper";
import { debounce } from "../../../helpers/Debounce";

function _success(success) {
  return { type: "GET_ORGANIZATION_FAILED_SITE_SUCCESS", success };
}

function _error(error) {
  return { type: "GET_ORGANIZATION_FAILED_SITE_ERROR", error };
}

function _processing(processing) {
  return { type: "GET_ORGANIZATION_FAILED_SITE_PROCESSING", processing };
}

function getOrganizationFailedTnx(id, shouldDebounce = false) {
  return (dispatch, getState) => {
    dispatch(_processing(true));
    dispatch(_success(null));
    dispatch(_error(null));

    const { params } = getState().organizationFailedTnxList?.data;

    const request = () =>
      axios({
        url: apiBaseUrl(`admin/organizations/${id}/failed-site-transactions`),
        method: "get",
        dataType: "json",
        params,
        headers: { Authorization: "Bearer " + loginToken() },
      })
        .then(function (res) {
          dispatch(_success(res?.data?.data));
          dispatch(_processing(false));
        })
        .catch(function (error) {
          if (error && error?.response && error?.response?.status === 401) {
            logOut();
          } else {
            handleError(error);
            dispatch(_error(error));
            dispatch(_processing(false));
          }
        });

    debounce.makeRequest(request, shouldDebounce);
  };
}

export default getOrganizationFailedTnx;
